$(function(){
	var $document = $(document),
		$window = $(window),
		w = window.innerwidth ? window.innerwidth : $window.width(),
		h = window.innerHeight ? window.innerHeight : $window.height()
		st = $window.scrollTop();
	$('a[href^="#"]').click(function(){
		var speed = 500;
		var href= $(this).attr("href");
		var target = $(href == "#" || href == "" ? 'html' : href);
    if (window.matchMedia('(max-width:767px)').matches) {
	  var position = target.offset().top-80; // スマホ
	    } else {
	  var position = target.offset().top-30; // PC
	    }
		$("html, body").animate({scrollTop:position}, speed, "swing");
		return false;
	});
	var $setElem = $('.switch'),
	pcName = '_pc.',
	spName = '_sp.',
	replaceWidth = 768;
	$setElem.each(function(){
		var $this = $(this);
		function imgSize(){
			var windowWidth = parseInt(window.innerWidth);
			if(windowWidth >= replaceWidth) {
				$this.attr('src',$this.attr('src').replace(spName,pcName)).css({visibility:'visible'});
			} else if(windowWidth < replaceWidth) {
				$this.attr('src',$this.attr('src').replace(pcName,spName)).css({visibility:'visible'});
			}
		}
		$(window).on('load resize', function(){imgSize();});
	});
	var scroll_timer = false;
	
	$window.scroll(function () {
		if (scroll_timer !== false) {
			clearTimeout(scroll_timer);
		}
		scroll_timer = setTimeout(function() {
			h = window.innerHeight ? window.innerHeight : $window.height();
			st = $window.scrollTop();
			var dh = $document.height();
			$('.scroll_anime:not(.anime_show)').each(function(index) {
				var elm = $(this);
				var elmPos = $(this).offset().top - 20;
				if(st > elmPos - h/1.2){
					TweenMax.killTweensOf(elm);
					TweenMax.to(elm, 1, { top:'-=20px', opacity: 1, ease: Power3.easeOut});
					elm.addClass('anime_show');
				}
			});
		}, 10);
	});
});